export default "__VITE_ASSET__DQVDkDBW__"